import { DYNAMIC_REQUEST_EDIT_PATH } from "@/modules/requests/pages/dynamic-request";
import { generatePath, Navigate } from "react-router-dom";

export function OpenDynamicApprovingRequest() {
  return (
    <Navigate
      to={generatePath(DYNAMIC_REQUEST_EDIT_PATH, {
        id: new URL(window.location.href).searchParams.get("id"),
        type: new URL(window.location.href).searchParams.get("type"),
      })}
    />
  );
}
